import { render, staticRenderFns } from "./ShippingMegaRouting.vue?vue&type=template&id=0ffa330a"
import script from "./ShippingMegaRouting.vue?vue&type=script&lang=js"
export * from "./ShippingMegaRouting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports